/* istanbul ignore file */
export const STEP_1 = 1
export const STEP_2 = 2
export const STEP_4 = 4
export const STEP_3 = 3
export const STEP_PRE_BOOKING = 5

export const SUPPLIER_SIXT = 3
